import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { gql, useMutation } from '@apollo/client'

import ConfirmationModal from 'js/components/Modal/ConfirmationModal'

import LockIcon from 'icons/lock.svg'
import UnlockIcon from 'icons/unlock.svg'

import ActionButton from './ActionButton'

const LockButton = ({
    entity,
}: {
    entity: {
        guid: string
        isLocked: boolean
        title: string
    }
}) => {
    const { t } = useTranslation()

    const { guid, isLocked, title } = entity

    const [lockFile, { loading }] = useMutation(LOCK_FILE)

    const [showConfirmLockModal, setShowConfirmLockModal] = useState(false)
    const [showConfirmUnlockModal, setShowConfirmUnlockModal] = useState(false)

    const toggleLock = () => {
        const shouldLock = !isLocked

        lockFile({
            variables: {
                input: {
                    guid,
                    shouldLock,
                },
            },
        })
            .then(() => {
                setShowConfirmLockModal(false)
                setShowConfirmUnlockModal(false)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const sharedConfirmModalProps = {
        cancelLabel: t('action.cancel'),
        confirmLabel: t('action.confirm'),
        onConfirm: toggleLock,
        loading,
    }

    return (
        <>
            <ActionButton
                variant={isLocked ? 'primary' : 'secondary'}
                tooltip={isLocked ? t('action.unlock') : t('action.lock')}
                onClick={() =>
                    isLocked
                        ? setShowConfirmUnlockModal(true)
                        : setShowConfirmLockModal(true)
                }
            >
                {isLocked ? <UnlockIcon /> : <LockIcon />}
            </ActionButton>
            <ConfirmationModal
                title={t('entity-file.lock-file')}
                isVisible={showConfirmLockModal}
                onCancel={() => setShowConfirmLockModal(false)}
                {...sharedConfirmModalProps}
            >
                <Trans i18nKey="entity-file.lock-file-confirm">
                    Are you sure you want to lock {{ title }}? Others cannot
                    edit or download the file untill you unlock it again.
                </Trans>
            </ConfirmationModal>
            <ConfirmationModal
                title={t('entity-file.unlock-file')}
                isVisible={showConfirmUnlockModal}
                onCancel={() => setShowConfirmUnlockModal(false)}
                {...sharedConfirmModalProps}
            >
                <Trans i18nKey="entity-file.lock-file-confirm">
                    Are you sure you want to lock {{ title }}? Others cannot
                    edit or download the file untill you unlock it again.
                </Trans>
            </ConfirmationModal>
        </>
    )
}

const LOCK_FILE = gql`
    mutation Lock($input: LockFileInput!) {
        lockFile(input: $input) {
            success
            entity {
                guid
                ... on File {
                    isLocked
                    canLock
                    canUnlock
                }
            }
        }
    }
`

export default LockButton
